module.exports = __webpack_public_path__ + "src/assets/img/light_stop.facc7a2b.svg";